import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Media extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'Media'
  // Define default properties here
  static instanceDefaults () {
    return {
      mimetype: null,
      location: null,
      filepath: null,
    }
  }
}
const servicePath = 'media'
const servicePlugin = makeServicePlugin({
  Model: Media,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
